// extracted by mini-css-extract-plugin
export default {"navWrapper":"tab_navWrapper__6wfZN","navigator":"tab_navigator__KYDlj","rightOption":"tab_rightOption__+lddn","verticalLine":"tab_verticalLine__kjAr-"};